<div class="bg-white flex flex-col gap-4 p-4 border border-gray-200 rounded-lg min-h-0">
  <!-- AUSWAHLMODUS -->
  <div class="flex flex-col gap-1 pt-2 pb-1">
    <span class="text-[11px] font-medium text-gray-400 uppercase">Auswahlmodus</span>
    <div class="border-b border-gray-200"></div>
  </div>
  <label class="text-sm font-medium text-gray-900 leading-normal">Wie sollen Prüfregeln zugeordnet werden?*</label>
  <div class="grid grid-cols-2 gap-4 -mt-2">
    <button
      (click)="selectMode('manual')"
      [class]="state.ruleSelectionMode === 'manual' ? 'border-gray-500 bg-gray-100' : 'border-gray-200 bg-white hover:border-gray-300'"
      class="flex items-center gap-4 px-4 py-2 rounded-lg border transition-colors text-left">
      <div class="flex items-center justify-center w-6 h-6 shrink-0">
        <fa-icon
          [icon]="faHandPointer"
          [class]="state.ruleSelectionMode === 'manual' ? 'text-gray-500' : 'text-gray-300'"
          class="text-base"></fa-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-sm font-medium text-gray-900 leading-normal">Manuell</span>
        <span class="text-xs font-normal text-gray-900 leading-normal">Nutzer wählt Regeln zur Laufzeit aus erlaubten Sets</span>
      </div>
    </button>
    <button
      (click)="selectMode('predefined')"
      [class]="state.ruleSelectionMode === 'predefined' ? 'border-gray-500 bg-gray-100' : 'border-gray-200 bg-white hover:border-gray-300'"
      class="flex items-center gap-4 px-4 py-2 rounded-lg border transition-colors text-left">
      <div class="flex items-center justify-center w-6 h-6 shrink-0">
        <fa-icon
          [icon]="faThumbtackAngle"
          [class]="state.ruleSelectionMode === 'predefined' ? 'text-gray-500' : 'text-gray-300'"
          class="text-base"></fa-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-sm font-medium text-gray-900 leading-normal">Vordefiniert</span>
        <span class="text-xs font-normal text-gray-900 leading-normal">Regeln sind fest zugeordnet, bei jeder Ausführung gleich</span>
      </div>
    </button>
  </div>

  <!-- Konfiguration: Anzuwendende Regeln und Sets -->
  <div class="flex flex-col gap-1 pt-2 pb-1">
    <span class="text-[11px] font-medium text-gray-400 uppercase">Konfiguration</span>
    <div class="border-b border-gray-200"></div>
  </div>
  <div class="flex flex-col gap-3 min-h-0">
      <!-- Suchfeld + Neues Regelset -->
      <div class="flex items-end gap-3">
        <div class="flex-1 min-w-0">
          <bic-input (valueChange)="searchQuery = $event"
                     [iconStart]="faSearch"
                     [label]="'Verfügbare Regeln & Sets zur Ausführung*'"
                     [placeholder]="'Suche nach Regel oder Set…'"
                     [required]="true"
                     [value]="searchQuery">
          </bic-input>
        </div>
        <button (click)="createNewRuleset()"
                class="flex items-center gap-2 h-[38px] px-3 shrink-0 whitespace-nowrap rounded-lg border border-gray-300 bg-white text-sm font-medium text-gray-900 hover:bg-gray-50 transition-colors"
                type="button">
          <fa-icon [icon]="faPlus" class="text-xs"></fa-icon>
          Neues Regelset
        </button>
      </div>

      @if (showErrors && state.selectedRuleSetIds.length === 0 && state.selectedRuleIds.length === 0) {
        <span class="text-xs text-red-600">Mindestens ein myCheck oder eine Prüfregel muss ausgewählt sein.</span>
      }

      @if (loading) {
        <div class="border border-gray-200 rounded-lg py-1">
          @for (i of [1, 2, 3]; track i) {
            <div class="h-10 mx-3 my-1 rounded bg-gray-100 animate-pulse"></div>
          }
        </div>
      } @else if (filteredPrebuilt.length === 0 && filteredCustom.length === 0) {
        <div class="border border-gray-200 rounded-lg text-sm text-gray-500 py-4 text-center">Keine Regelsets gefunden.</div>
      } @else {
        <!-- Flache Liste aller Regelsets in einem Container -->
        <div class="border border-gray-200 rounded-lg py-1 min-h-0 overflow-y-auto">
          @for (ruleset of allFilteredRulesets; track ruleset.id) {
            <ng-container *ngTemplateOutlet="rulesetRow; context: {$implicit: ruleset}"></ng-container>
          }
        </div>
      }

      <!-- Zusammenfassung der Auswahl -->
      @if (!loading && !rulesPreloadPending && hasSelection) {
        <div class="text-xs text-gray-900 leading-normal">
          @if (selectedSetCount > 0) {
            <span class="font-medium">{{ selectedSetCount }}</span>
            {{ selectedSetCount === 1 ? 'Set' : 'Sets' }}
            ({{ selectedSetRuleCount }} {{ selectedSetRuleCount === 1 ? 'Prüfung' : 'Prüfungen' }})
          }
          @if (selectedSetCount > 0 && selectedSingleRuleCount > 0) {
            <span> + </span>
          }
          @if (selectedSingleRuleCount > 0) {
            <span class="font-medium">{{ selectedSingleRuleCount }}</span>
            {{ selectedSingleRuleCount === 1 ? 'einzelne Regel' : 'einzelne Regeln' }}
          }
          <span> = </span>
          <span class="font-medium">{{ totalAppliedRuleCount }}</span>
          {{ totalAppliedRuleCount === 1 ? 'Prüfregel wird' : 'Prüfregeln werden' }} angewendet
        </div>
      }

      <!-- Auswahl verweist auf nicht mehr vorhandene Regelsets/Regeln (z. B. zwischenzeitlich gelöscht) -->
      @if (!loading && !rulesPreloadPending && staleSelectionCount > 0) {
        <div class="flex items-center justify-between gap-3 px-3 py-2 rounded-lg bg-yellow-50 border border-yellow-200">
          <span class="text-xs text-yellow-800">
            {{ staleSelectionCount }}
            {{ staleSelectionCount === 1 ? 'gespeicherter Eintrag verweist' : 'gespeicherte Einträge verweisen' }}
            auf nicht mehr vorhandene Regeln oder Regelsets und {{ staleSelectionCount === 1 ? 'wird' : 'werden' }}
            nicht angewendet.
          </span>
          <button (click)="clearStaleSelection()"
                  class="shrink-0 whitespace-nowrap px-3 py-1 rounded-lg border border-yellow-300 bg-white text-xs font-medium text-yellow-900 hover:bg-yellow-100 transition-colors"
                  type="button">
            Bereinigen
          </button>
        </div>
      }

      <!-- Hinweis nur im vordefinierten Modus -->
      @if (state.ruleSelectionMode === 'predefined') {
        <div class="flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-100">
          <fa-icon [icon]="faCircleInfo" class="text-gray-500 text-sm shrink-0"></fa-icon>
          <span class="text-sm font-medium text-gray-500">
            Im vordefinierten Modus sehen die Nutzer*innen zur Ausführung keine Auswahl und können die Regeln nicht ändern.
          </span>
        </div>
      }
  </div>
</div>

<!-- Wiederverwendbare Regelset-Zeile mit Aufklapp-Funktion (Figma: flache Liste) -->
<ng-template #rulesetRow let-ruleset>
  <!-- Set-Kopfzeile -->
  <div class="flex items-center gap-2 pl-3 pr-4 min-h-[40px] hover:bg-gray-50 transition-colors">
    <!-- Aufklapp-Chevron -->
    <button
      (click)="toggleExpand(ruleset)"
      [class.invisible]="!isExpandable(ruleset)"
      class="flex items-center justify-center w-4 h-6 shrink-0 text-gray-500 hover:text-gray-900"
      type="button">
      <fa-icon [icon]="faChevronDown"
               [class.rotate-180]="isExpanded(ruleset)"
               class="text-xs transition-transform"></fa-icon>
    </button>

    <!-- Set-Checkbox + Name -->
    <button
      (click)="toggleRuleset(ruleset)"
      class="flex items-center gap-2 flex-1 min-w-0 text-left"
      type="button">
      <span
        [class]="isSelected(ruleset) || isPartiallySelected(ruleset) ? 'bg-green border-green text-white' : 'bg-gray-50 border-gray-300'"
        class="flex items-center justify-center w-4 h-4 rounded border shrink-0">
        @if (isSelected(ruleset)) {
          <fa-icon [icon]="faCheck" class="text-[10px]"></fa-icon>
        } @else if (isPartiallySelected(ruleset)) {
          <fa-icon [icon]="faMinus" class="text-[10px]"></fa-icon>
        }
      </span>
      <span class="text-sm text-gray-900 truncate">{{ ruleset.name }}</span>
    </button>

    <!-- Anzahl-Badge (transparent) -->
    <span class="text-xs font-medium text-gray-700 whitespace-nowrap shrink-0">{{ getSetCountLabel(ruleset) }}</span>

    <!-- Typ-Badge (grau) -->
    <span class="px-2.5 py-0.5 text-xs font-medium text-gray-700 bg-gray-200 rounded-md whitespace-nowrap shrink-0">{{ getTypeLabel(ruleset.type) }}</span>

    <!-- Link zum Regelset: nur öffenbar mit Bearbeitungsrecht (zentral bereitgestellte Sets sind gesperrt) -->
    @if (canOpen(ruleset)) {
      <button
        (click)="openRuleset(ruleset, $event)"
        class="flex items-center justify-center w-5 h-5 shrink-0 text-gray-400 hover:text-gray-700"
        title="Regelset öffnen"
        type="button">
        <fa-icon [icon]="faArrowUpRightFromSquare" class="text-xs"></fa-icon>
      </button>
    }
  </div>

  <!-- Aufgeklappte Einzelregeln (flache Liste, eingerückt via pl-12) -->
  @if (isExpanded(ruleset)) {
    <div class="flex flex-col">
      @if (rulesLoading[ruleset.id]) {
        @for (i of [1, 2]; track i) {
          <div class="mx-3 my-1 h-8 rounded bg-gray-100 animate-pulse"></div>
        }
      } @else if (getRules(ruleset).length === 0) {
        <div class="pl-12 pr-4 py-3 text-xs text-gray-500">Keine Einzelregeln verfügbar.</div>
      } @else {
        @for (rule of getRules(ruleset); track rule.id) {
          <div class="flex items-center gap-3 pl-12 pr-4 min-h-[40px] hover:bg-gray-50 transition-colors">
            <button
              (click)="toggleRule(ruleset, rule)"
              class="flex items-center gap-2 flex-1 min-w-0 text-left"
              type="button">
              <span
                [class]="isRuleSelected(ruleset, rule) ? 'bg-green border-green text-white' : 'bg-gray-50 border-gray-300'"
                class="flex items-center justify-center w-4 h-4 rounded border shrink-0">
                @if (isRuleSelected(ruleset, rule)) {
                  <fa-icon [icon]="faCheck" class="text-[10px]"></fa-icon>
                }
              </span>
              @if (ruleset.type !== 'IDS') {
                <span class="text-sm font-medium text-gray-900 shrink-0 w-[60px]">{{ rule.code || '-' }}</span>
              }
              <span class="text-sm text-gray-900 truncate">{{ rule.name }}</span>
            </button>
            <!-- Link zur einzelnen Regel: nur öffenbar mit Bearbeitungsrecht -->
            @if (canOpen(ruleset)) {
              <button
                (click)="openRule(ruleset, rule, $event)"
                class="flex items-center justify-center w-5 h-5 shrink-0 text-gray-400 hover:text-gray-700"
                title="Regel öffnen"
                type="button">
                <fa-icon [icon]="faArrowUpRightFromSquare" class="text-xs"></fa-icon>
              </button>
            }
          </div>
        }
      }
    </div>
  }
</ng-template>
